import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import './Breadcrumb.scss';

const breadcrumbNameMap: { [key: string]: string } = {
  '/services': 'Services',
  '/services/ship-building': 'Ship Building',
  '/services/ship-rental': 'Ship Rental',
  '/services/crude-oil-vessel': 'Crude Oil Vessel',
  '/services/rocks-and-sand': 'Rocks And Sand',
  '/about': 'About',
  '/contact': 'Contact'
};

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <div className="breadcrumb-container">
      <Breadcrumbs aria-label="breadcrumb">
        <Link className="link-no-style link-blue" color="inherit" to="/">
          Home
        </Link>
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;

          return last ? (
            <Typography key={to} sx={{ color: 'text.primary' }}>
              {breadcrumbNameMap[to]}
            </Typography>
          ) : (
            <Link className='link-no-style link-blue' color="inherit" to={to} key={to}>
              {breadcrumbNameMap[to]}
            </Link>
          );
        })}
      </Breadcrumbs>
    </div>
  );
};

export default Breadcrumb;